import { Currency } from '../enum/currency'
import { Duration } from './settings'
import { applyEntitySchema, sourceJson } from '../../_utils/fcdc-v2'
import {
  lengthPriceCapSchema,
  priceCapBlockSchema,
  priceSchema,
} from '../schema/pricing.schema'

export class Price {
  currency: Currency
  amount: string

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.currency = source.currency
    this.amount = source.amount
    applyEntitySchema(this, priceSchema, source, {})
  }
}

export class PriceCapBlock {
  priceCategoryId: string
  priceCap: Price
  length: Duration
  repeating: boolean

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.priceCategoryId = source.priceCategoryId
    this.length = source.length
    this.priceCap = source.priceCap
    this.repeating = source.repeating
    applyEntitySchema(this, priceCapBlockSchema, source, {})
  }
}

export class LengthPriceCap {
  blocks: PriceCapBlock[]

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.blocks = Array.isArray(source.blocks)
      ? source.blocks.map((block: any) => new PriceCapBlock(block))
      : []
    applyEntitySchema(this, lengthPriceCapSchema, source, { blocks: [] })
  }
}
